import { useQuery } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../../../api";
import urls from "../../../urls";
import type { StartPageCompany } from "../StartPage.types";

function useStartPageCompanies(projectId?: string) {
  const { data, error, isLoading } = useQuery({
    queryKey: urls.startPage.companies.key(projectId),
    queryFn: () => fetchStartPageCompanies(projectId)
  });

  return {
    companies: data,
    isLoading,
    error
  };
}

async function fetchStartPageCompanies(projectId?: string) {
  const response = await apiWithoutCamelization.get<Array<StartPageCompany>>(
    urls.startPage.companies.url(projectId)
  );
  return response.data;
}

export { useStartPageCompanies };
